(function () {
  "use strict";

  // Nhận diện link ảnh custom upload dựa vào domain S3 + thư mục custom-uploads
  var S3_LINK_PATTERN = /amazonaws\.com\/.*custom-uploads\//i;

  function enhancePhotoLinks(root) {
    var scope = root || document;

    // Trường hợp 1: link dạng <a href="..."> (dùng ở trang Cart)
    var links = scope.querySelectorAll('a[href]');
    links.forEach(function (link) {
      if (link.dataset.photoEnhanced) return;
      if (!S3_LINK_PATTERN.test(link.href)) return;

      link.dataset.photoEnhanced = "true";
      link.classList.add("custom-photo-thumb-link");
      link.removeAttribute("target");

      var imgUrl = link.href;
      link.textContent = "";

      var thumb = document.createElement("img");
      thumb.src = imgUrl;
      thumb.alt = "Uploaded photo preview";
      link.appendChild(thumb);

      var label = document.createElement("span");
      label.textContent = "Preview";
      link.appendChild(label);

      link.addEventListener("click", function (e) {
        e.preventDefault();
        openLightbox(imgUrl);
      });
    });

    // Trường hợp 2: thẻ <img src="..."> đứng riêng (dùng ở trang Product,
    // trong khối .custom-photo-preview do custom-photo-upload.js tạo ra)
    var images = scope.querySelectorAll(".custom-photo-preview img");
    images.forEach(function (img) {
      if (img.dataset.photoEnhanced) return;
      if (!S3_LINK_PATTERN.test(img.src)) return;

      img.dataset.photoEnhanced = "true";
      img.style.cursor = "zoom-in";

      img.addEventListener("click", function () {
        openLightbox(img.src);
      });
    });
  }

  function openLightbox(src) {
    var existing = document.querySelector(".custom-photo-lightbox-overlay");
    if (existing) existing.remove();

    var overlay = document.createElement("div");
    overlay.className = "custom-photo-lightbox-overlay";

    var img = document.createElement("img");
    img.src = src;
    img.alt = "Custom photo";
    overlay.appendChild(img);

    overlay.addEventListener("click", function () {
      overlay.remove();
    });

    document.addEventListener("keydown", function escHandler(e) {
      if (e.key === "Escape") {
        overlay.remove();
        document.removeEventListener("keydown", escHandler);
      }
    });

    document.body.appendChild(overlay);
  }

  // Chạy lần đầu khi trang tải xong
  document.addEventListener("DOMContentLoaded", function () {
    enhancePhotoLinks(document);
  });

  // Theo dõi thay đổi DOM (khi cart cập nhật qua AJAX, ví dụ đổi số lượng)
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.addedNodes && m.addedNodes.length) {
        enhancePhotoLinks(document);
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();